import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import FlatButton from 'material-ui/FlatButton';
import ActionList from 'material-ui/svg-icons/action/list';

const styles = {
    button: {overflow: 'inherit'},
};

const ListButton = ({basePath = '', label = 'aor.action.list'}) => (
    <FlatButton
        primary
        label={label}
        icon={<ActionList/>}
        containerElement={<Link to={basePath}/>}
        style={styles.button}
    />
);

ListButton.propTypes = {
    basePath: PropTypes.string,
    label: PropTypes.string,
};

export default ListButton;



// WEBPACK FOOTER //
// ./src/Fuse/buttons/ListButton.js